// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-ugc-track-properties {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: flex-start;
  background-color: white;
  font-style: normal;
  overflow: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
wm-ugc-track-properties .wm-ugc-track-form-readonly ion-card {
  box-shadow: none;
}
wm-ugc-track-properties ion-header .wm-ugc-track-details-header {
  font-size: var(--font-md);
  color: #333333;
  font-style: normal;
  font-weight: 600;
  display: flex;
  align-items: center;
  flex: none;
  order: 0;
  flex-grow: 0;
  padding: 10px;
}
wm-ugc-track-properties ion-grid {
  width: 100%;
}
wm-ugc-track-properties #wm-ugc-track-details-content {
  width: 100%;
  height: calc(100% - 56px);
  font-family: var(--wm-font-family-content);
  padding: 0px 10px;
  display: flex;
  flex-direction: column;
  flex-wrap: inherit;
  align-self: flex-start;
}
wm-ugc-track-properties #wm-ugc-track-details-content > *:empty {
  display: none;
}
wm-ugc-track-properties #wm-ugc-track-details-content .wm-ugc-track-title:first-letter {
  text-transform: uppercase;
}
wm-ugc-track-properties #wm-ugc-track-details-content .wm-ugc-category-title {
  font-weight: var(--wm-feature-details-title-font-weight);
  font-size: var(--wm-feature-details-title-font-size);
  color: var(--wm-feature-details-title-color);
  font-family: var(--wm-feature-details-title-font-family);
}
wm-ugc-track-properties #wm-ugc-track-details-content .wm-ugc-track-activity-content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/ugc-track-properties/ugc-track-properties.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;AACF;AAEI;EACE,gBAAA;AAAN;AAII;EACE,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;AAFN;AAKE;EACE,WAAA;AAHJ;AAME;EACE,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;AAJJ;AAKI;EACE,aAAA;AAHN;AAKI;EACE,yBAAA;AAHN;AAKI;EACE,wDAAA;EACA,oDAAA;EACA,4CAAA;EACA,wDAAA;AAHN;AAKI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,uBAAA;AAHN","sourcesContent":["wm-ugc-track-properties {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-content: stretch;\n  align-items: flex-start;\n  background-color: white;\n  font-style: normal;\n  overflow: scroll;\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n\n  .wm-ugc-track-form-readonly {\n    ion-card {\n      box-shadow: none;\n    }\n  }\n  ion-header {\n    .wm-ugc-track-details-header {\n      font-size: var(--font-md);\n      color: #333333;\n      font-style: normal;\n      font-weight: 600;\n      display: flex;\n      align-items: center;\n      flex: none;\n      order: 0;\n      flex-grow: 0;\n      padding: 10px;\n    }\n  }\n  ion-grid {\n    width: 100%;\n  }\n\n  #wm-ugc-track-details-content {\n    width: 100%;\n    height: calc(100% - 56px);\n    font-family: var(--wm-font-family-content);\n    padding: 0px 10px;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: inherit;\n    align-self: flex-start;\n    > *:empty {\n      display: none;\n    }\n    .wm-ugc-track-title:first-letter {\n      text-transform: uppercase;\n    }\n    .wm-ugc-category-title {\n      font-weight: var(--wm-feature-details-title-font-weight);\n      font-size: var(--wm-feature-details-title-font-size);\n      color: var(--wm-feature-details-title-color);\n      font-family: var(--wm-feature-details-title-font-family);\n    }\n    .wm-ugc-track-activity-content {\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n      justify-content: flex-start;\n      align-content: flex-start;\n      align-items: flex-start;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
